export enum QuestionType {
  SingleSelect = "single-select",
  MultiSelect = "multi-select",
  OpenEnded = "open-ended",
  Anatomy = "anatomy",
}

export interface SingleSelectState {
  selectedOptionIndex?: number;
  submittedOptionIndexes: number[];
}

export interface MultiSelectState {
  selectedOptionIds: number[];
  submittedOptionIds: number[];
  attemptsCount: number;
  hasAttempted: boolean;
}

export interface OpenEndedState {
  value: string;
  isCompleted: boolean;
  textChanged: boolean;
}

export interface AnatomyState {
  answers: Record<string, string>;
  correctAnswers: string[];
  incorrectAnswers: string[];
  isSubmitted: boolean;
  showFeedback: boolean;
}

export interface QuestionHandlers {
  selectOption: (optionIndex: number) => void;
  toggleOption: (optionId: number) => void;
  setValue: (value: string) => void;
  setAnswer: (calloutId: string, value: string) => void;
  submitAnatomy: (callouts: { id: string; correctAnswer: string }[]) => void;
  submit: () => void;
  reset: () => void;
  tryAgain: () => void;
}

export interface QuestionContextValue {
  getSingleSelectState: (componentId: string | number) => SingleSelectState;
  getMultiSelectState: (componentId: string | number) => MultiSelectState;
  getOpenEndedState: (componentId: string | number) => OpenEndedState;
  getAnatomyState: (componentId: string | number) => AnatomyState;
  getQuestionHandlers: (
    componentId: string | number,
    type: QuestionType
  ) => QuestionHandlers;
}

export interface SingleSelectReturn {
  selectedOptionIndex?: number;
  submittedOptionIndexes: number[];
  selectOption: (optionIndex: number) => void;
  submit: () => void;
  reset: () => void;
}

export interface MultiSelectReturn {
  selectedOptionIds: number[];
  submittedOptionIds: number[];
  attemptsCount: number;
  hasAttempted: boolean;
  toggleOption: (optionId: number) => void;
  submit: () => void;
  reset: () => void;
  tryAgain: () => void;
}

export interface OpenEndedReturn {
  value: string;
  isCompleted: boolean;
  textChanged: boolean;
  setValue: (value: string) => void;
  submit: () => void;
  reset: () => void;
}

export interface AnatomyReturn {
  answers: Record<string, string>;
  correctAnswers: string[];
  incorrectAnswers: string[];
  isSubmitted: boolean;
  showFeedback: boolean;
  setAnswer: (calloutId: string, value: string) => void;
  submitAnatomy: (callouts: { id: string; correctAnswer: string }[]) => void;
  reset: () => void;
}

export type CombinedQuestionState = SingleSelectReturn &
  MultiSelectReturn &
  OpenEndedReturn &
  AnatomyReturn;
